import React from "react";
import { Link } from "react-router-dom";
interface LogoProps {
  inverted?: boolean;
}
export function Logo({
  inverted = false
}: LogoProps) {
  return <Link to="/" className="flex items-center gap-2.5 rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2" aria-label="RD-Kiné, retour à l'accueil" data-id="element-270" data-mp="y8thcr59j7wj">
      <span className={`relative flex h-10 w-10 items-center justify-center rounded-full text-sm font-bold ${inverted ? "bg-white text-brand" : "bg-brand text-white"}`} aria-hidden="true" data-id="element-271" data-mp="kbn3nazebze6">
        RD
        <span className="absolute -right-0.5 top-1 h-2.5 w-2.5 rounded-full bg-accent ring-2 ring-white" data-id="element-272" data-mp="altv6iujw0e5" />
      </span>
      <span className={`text-lg font-semibold tracking-tight ${inverted ? "text-white" : "text-brand"}`} data-id="element-273" data-mp="5k4hswjuvamw">
        RD-Kiné
      </span>
    </Link>;
}